module.exports = __webpack_public_path__ + "media/images/Email-cd0500f9cd28531ff3d565f658912b37.png";